/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { baseComponentManager } from '../../registry/Components';
import { ComponentManagerFn } from '../../registry/Component.type';
import { ItemType } from '../../registry/ComponentRegistry';
import { defaultValue } from './ChatBot';
import { toOptions } from 'componentregistry/utils/ManagerUtils';

const ChatBotManager: ComponentManagerFn<'ChatBot'> = (platform: Platform) => {
  return {
    ...baseComponentManager<'ChatBot'>(platform, 'ChatBot'),
    type: 'ChatBot',
    name: 'ChatBot',
    isChildAllowed: (page, item, childType) =>
      (['TriggerOnClick'] as ItemType[]).includes(childType),
    defaultValue,
    props: {
      botName: {
        label: 'ChatBot Name',
        type: 'string',
        helpText: 'Specify a name for the ChatBot.',
      },
      welcomeMessage: {
        label: 'Welcome Message',
        type: 'expression',
        returnType: async () => 'string',
        helpText: 'Specify the welcome message.',
      },
      askAPI: {
        label: 'ChatBot API',
        type: 'select',
        required: true,
        options: toOptions(['Python', 'Rust']),
        category: 'Flex',
      },
      wfId: {
        label: 'Workflow Id',
        type: 'string',
        helpText: 'Specify workflow for ChatBot.',
      },
      confidenceThreshold: {
        label: 'Threshold Confidence',
        type: 'number',
        helpText: 'Specify Threshold Confidence for ChatBot.',
      },
    },
    // props: {
    //   dsalias: {
    //     category: 'Data',
    //     label: 'DataSource Alias',
    //     required: true,
    //     type: 'DataSourceAliasChooser',
    //     allowedTypes: [
    //       'CloudDataStore',
    //       'DataStore',
    //       'LocalDataStore',
    //       'ReadOnlyDataStore',
    //     ],
    //   },
    // },
    // getDataSourceAliasProperty: (aliasType: AliasType) =>
    //   aliasType === 'LOV'
    //     ? { aliasProp: 'dsalias', embeddedPageIdProp: 'embeddedPageId' } // TODO: Add embeddedPageId prop
    //     : undefined,
    // isDataSourceAliasUsed: (item, alias) => item.props.dsalias === alias,
    // getDisplayText: (item) => item.props.icon?.iconName ?? 'Choose icon!',
    category: 'Forms',
    icon: { iconName: 'message-bot' },
    description: 'Chatbot',
  };
};

export default ChatBotManager;
